export const CCBP_ACADEMY_IITIANS_WEBINAR_SOCIALMEDIA =
  'CCBP_ACADEMY_IITIANS_WEBINAR_SOCIALMEDIA';
export const ACADEMY_AI_WORKSHOP = 'ACADEMY_AI_WORKSHOP';
export const ACADEMY_MCP_WORKSHOP = 'ACADEMY_MCP_WORKSHOP';

export const productsWithAuthenticationAndSubmitForm = [
  'NIAT_WEBINAR_REGISTRATION',
  CCBP_ACADEMY_IITIANS_WEBINAR_SOCIALMEDIA
];
